import React, { forwardRef, useEffect, useState, useMemo, useCallback } from 'react';
import ToolsIntegrationsAPI from 'restAPI/ToolsIntegrationAPI';
import { FieldTypes } from 'utils/formUtils';
import message from "components/CustomMessage";
import GenericMappingForm from '../GenericMappingForm';

const AcunetixMappingForm = forwardRef(function AcunetixMappingForm({ disableProjectFields = false, ...props }, ref) {
  const [initialValues] = useState(() => {
    if (props.record) {
      return undefined;
    }
    return [
      {
        product: props.defaultProduct,
        subProduct: props.defaultSubProduct,
        subProductId: props.defaultSubProductId,
        environment: props.defaultEnvironment,
      },
    ];
  });
  const [projects, setProjects] = useState(() => {
    if (props.record) {
      const { websiteId, websiteName } = props.record;
      const websiteIdArray = websiteId.split(',');
      const websiteNameArray = websiteName.split(',');
      return websiteIdArray.map((id, index) => ({id, name: websiteNameArray[index] }))
    }
    return [];
  });

  useEffect(() => {
    const { promise, cancel } = ToolsIntegrationsAPI.getGenericProjectByToolName(props.toolName, { login_id: props.loginConfigId });
    promise.then((response) => {
      const { projects } = response;
      setProjects(projects);
    }).catch(() => {
      message.error('Problem fetching projects');
    });

    return cancel;
  }, [props.loginConfigId,props.toolName]);

  const getExtraFieldsData = (config) => {
    const { websiteId } = config;
    const data = projects.reduce((acc,cv) =>{
      const { id, name , otherProperties} = cv;
      if(websiteId.includes(id)){
        acc.id.push(id);
        acc.name.push(name);
        acc.url.push(otherProperties.rootUrl)
      }
      return acc;
    },{id:[],name:[], url: []})

    return ({
      websiteId:data.id.join(),
      websiteName: data.name.join(),
      websiteUrl: data.url.join()
    });
  }

  const parseExtraFieldsDataFromResponse = useCallback((config) => {
    const { websiteId, websiteName } = config;
    return {
      websiteId: websiteId.split(","),
      websiteName: websiteName.split(","),
    };
  }, []);

  const extraFields = useMemo(() => ([
    {
      name: 'websiteId',
      colSpan: '12',
      type: FieldTypes.MULTI_SELECT,
      label: 'Website Name',
      options: projects,
      required:true,
      disabled: disableProjectFields,
      props: {
        autoFocus: !disableProjectFields
      }
    }
  ]), [projects, disableProjectFields]);

  return (
    <GenericMappingForm
      ref={ref}
      projects={projects}
      getExtraFieldsData={getExtraFieldsData}
      formDefaultValues={initialValues}
      parseExtraFieldsDataFromResponse={parseExtraFieldsDataFromResponse}
      extraFields={extraFields}
      {...props}
    />
  )
})

export default AcunetixMappingForm;
